import React, { useState } from 'react';
import { Calendar, Clock, Users, MapPin, Video, ChevronLeft, FileText, Download, MessageSquare, Send, CheckCircle, User, Edit, Trash2, X, Plus } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
export function MeetingDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [activeTab, setActiveTab] = useState('agenda');
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  // Mock meeting data - in a real app, this would be fetched from an API
  const meeting = {
    id: 1,
    title: 'المراجعة الشهرية للجنة المالية',
    committee: 'لجنة المالية',
    date: '2023-09-15',
    time: '10:00 صباحاً',
    duration: '60 دقيقة',
    type: 'عبر الإنترنت',
    location: 'https://zoom.us/j/1234567890',
    description: 'المراجعة الشهرية للتقارير المالية وتخطيط الميزانية للربع الرابع.',
    status: 'upcoming',
    organizer: 'محمد الهاشمي',
    attendees: [{
      id: 1,
      name: 'محمد الهاشمي',
      role: 'رئيس اللجنة',
      status: 'confirmed'
    }, {
      id: 2,
      name: 'عائشة المنصوري',
      role: 'أمين السر',
      status: 'confirmed'
    }, {
      id: 3,
      name: 'عمر الشامسي',
      role: 'عضو',
      status: 'pending'
    }, {
      id: 4,
      name: 'فاطمة الزعابي',
      role: 'عضو',
      status: 'confirmed'
    }, {
      id: 5,
      name: 'أحمد الظاهري',
      role: 'عضو',
      status: 'declined'
    }],
    agenda: [{
      id: 1,
      title: 'مراجعة محضر الاجتماع السابق',
      duration: '10 دقائق',
      presenter: 'عائشة المنصوري'
    }, {
      id: 2,
      title: 'مراجعة الأداء المالي للربع الثالث',
      duration: '20 دقيقة',
      presenter: 'محمد الهاشمي'
    }, {
      id: 3,
      title: 'إعداد مسودة ميزانية الربع الرابع',
      duration: '15 دقيقة',
      presenter: 'فاطمة الزعابي'
    }, {
      id: 4,
      title: 'مناقشة مفتوحة',
      duration: '10 دقائق',
      presenter: 'الجميع'
    }, {
      id: 5,
      title: 'بنود العمل والخطوات التالية',
      duration: '5 دقائق',
      presenter: 'محمد الهاشمي'
    }],
    documents: [{
      id: 1,
      name: 'محضر_الاجتماع_السابق.pdf',
      type: 'PDF',
      size: '1.2 ميجابايت'
    }, {
      id: 2,
      name: 'تقرير_مالي_الربع_الثالث.xlsx',
      type: 'XLSX',
      size: '2.4 ميجابايت'
    }, {
      id: 3,
      name: 'مسودة_ميزانية_الربع_الرابع.xlsx',
      type: 'XLSX',
      size: '1.8 ميجابايت'
    }],
    minutes: {
      notes: [{
        id: 1,
        agenda_item: 'مراجعة محضر الاجتماع السابق',
        content: 'تمت مراجعة محضر الاجتماع السابق والموافقة عليه بدون تغييرات.'
      }, {
        id: 2,
        agenda_item: 'مراجعة الأداء المالي للربع الثالث',
        content: 'قدم محمد الأداء المالي للربع الثالث. تجاوزت الإيرادات الأهداف بنسبة 12٪، بينما كانت النفقات أقل من الميزانية بنسبة 5٪. ناقشت اللجنة المحركات الرئيسية وراء هذه النتائج الإيجابية.'
      }, {
        id: 3,
        agenda_item: 'إعداد مسودة ميزانية الربع الرابع',
        content: 'قدمت فاطمة مسودة ميزانية الربع الرابع. اقترحت اللجنة زيادة مخصصات التسويق بنسبة 10٪ وخفض النفقات الإدارية بنسبة 5٪. سيتم تقديم ميزانية منقحة في الاجتماع القادم.'
      }, {
        id: 4,
        agenda_item: 'مناقشة مفتوحة',
        content: 'ناقشت اللجنة الحاجة إلى تحسين أدوات التقارير المالية. ستتم استشارة قسم تكنولوجيا المعلومات حول الخيارات المتاحة.'
      }, {
        id: 5,
        agenda_item: 'بنود العمل والخطوات التالية',
        content: 'ستقوم فاطمة بمراجعة ميزانية الربع الرابع. سيقوم محمد بالتنسيق مع قسم تكنولوجيا المعلومات بخصوص أدوات التقارير المالية. تم تحديد موعد الاجتماع القادم في 15 أكتوبر.'
      }],
      action_items: [{
        id: 1,
        description: 'مراجعة ميزانية الربع الرابع مع التغييرات المقترحة',
        assignee: 'فاطمة الزعابي',
        due_date: '2023-09-22'
      }, {
        id: 2,
        description: 'التنسيق مع قسم تكنولوجيا المعلومات بخصوص أدوات التقارير المالية',
        assignee: 'محمد الهاشمي',
        due_date: '2023-09-30'
      }, {
        id: 3,
        description: 'إعداد مسودة جدول أعمال للاجتماع القادم',
        assignee: 'عائشة المنصوري',
        due_date: '2023-10-08'
      }]
    },
    comments: [{
      id: 1,
      user: 'محمد الهاشمي',
      avatar: 'م',
      date: '2023-09-10',
      time: '14:30',
      content: 'يرجى مراجعة تقرير الربع الثالث المالي المرفق قبل الاجتماع.'
    }, {
      id: 2,
      user: 'عائشة المنصوري',
      avatar: 'ع',
      date: '2023-09-11',
      time: '09:15',
      content: 'لقد أعددت محضر اجتماعنا الأخير. يرجى إعلامي إذا كانت هناك أي تغييرات مطلوبة.'
    }, {
      id: 3,
      user: 'فاطمة الزعابي',
      avatar: 'ف',
      date: '2023-09-12',
      time: '11:45',
      content: 'مسودة ميزانية الربع الرابع متاحة الآن للمراجعة. لقد قمت بتسليط الضوء على التغييرات الرئيسية من الربع الثالث.'
    }]
  };
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'confirmed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'declined':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'PDF':
        return <FileText size={16} className="text-red-500" data-id="element-1353" />;
      case 'DOCX':
        return <FileText size={16} className="text-blue-500" data-id="element-1354" />;
      case 'XLSX':
        return <FileText size={16} className="text-green-500" data-id="element-1355" />;
      case 'PPTX':
        return <FileText size={16} className="text-orange-500" data-id="element-1356" />;
      default:
        return <FileText size={16} className="text-gray-500" data-id="element-1357" />;
    }
  };
  return <div dir="rtl" data-id="element-1358">
      <div className="flex items-center mb-6" data-id="element-1359">
        <Link to="/meetings" className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-1360">
          <ChevronLeft size={20} className="ml-1 transform rotate-180" data-id="element-1361" />
          العودة إلى الاجتماعات
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-1362">{meeting.title}</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1363">
        {/* Meeting Details */}
        <div className="lg:col-span-2" data-id="element-1364">
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1365">
            <div className="flex justify-between items-start mb-4" data-id="element-1366">
              <div data-id="element-1367">
                <h2 className="text-lg font-semibold" data-id="element-1368">{meeting.title}</h2>
                <p className="text-gray-500" data-id="element-1369">{meeting.committee}</p>
              </div>
              <div data-id="element-1370">
                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium" data-id="element-1371">
                  {meeting.status === 'upcoming' ? 'قادم' : meeting.status}
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-1372">
              <div data-id="element-1373">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1374">
                  التاريخ والوقت
                </h3>
                <div className="flex items-center" data-id="element-1375">
                  <Calendar size={16} className="text-gray-500 ml-2" data-id="element-1376" />
                  <span data-id="element-1377">
                    {meeting.date}، {meeting.time} ({meeting.duration})
                  </span>
                </div>
              </div>
              <div data-id="element-1378">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1379">
                  نوع الاجتماع
                </h3>
                <div className="flex items-center" data-id="element-1380">
                  {meeting.type === 'عبر الإنترنت' ? <Video size={16} className="text-blue-500 ml-2" data-id="element-1381" /> : <MapPin size={16} className="text-red-500 ml-2" data-id="element-1382" />}
                  <span data-id="element-1383">{meeting.type}</span>
                </div>
              </div>
              <div data-id="element-1384">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1385">
                  {meeting.type === 'عبر الإنترنت' ? 'رابط الاجتماع' : 'الموقع'}
                </h3>
                <div className="flex items-center" data-id="element-1386">
                  {meeting.type === 'عبر الإنترنت' ? <a href={meeting.location} className="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-1387">
                      الانضمام للاجتماع
                    </a> : <span data-id="element-1388">{meeting.location}</span>}
                </div>
              </div>
              <div data-id="element-1389">
                <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1390">
                  المنظم
                </h3>
                <div className="flex items-center" data-id="element-1391">
                  <div className="h-6 w-6 bg-gray-700 rounded-full flex items-center justify-center text-white text-xs font-medium ml-2" data-id="element-1392">
                    {meeting.organizer.charAt(0)}
                  </div>
                  <span data-id="element-1393">{meeting.organizer}</span>
                </div>
              </div>
            </div>
            <div className="mb-6" data-id="element-1394">
              <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1395">الوصف</h3>
              <p className="text-gray-700" data-id="element-1396">{meeting.description}</p>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-1397">
              <button className="px-3 py-1 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1398">
                <Edit size={16} className="inline ml-1" data-id="element-1399" />
                تعديل الاجتماع
              </button>
              <button className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors" data-id="element-1400">
                <X size={16} className="inline ml-1" data-id="element-1401" />
                إلغاء الاجتماع
              </button>
              <button className="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" onClick={() => setShowAttendanceModal(true)} data-id="element-1402">
                <CheckCircle size={16} className="inline ml-1" data-id="element-1403" />
                تسجيل الحضور
              </button>
            </div>
          </div>
          {/* Tabs */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1404">
            <div className="flex border-b border-gray-200" data-id="element-1405">
              <button className={`px-4 py-3 font-medium ${activeTab === 'agenda' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('agenda')} data-id="element-1406">
                جدول الأعمال
              </button>
              <button className={`px-4 py-3 font-medium ${activeTab === 'attendees' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('attendees')} data-id="element-1407">
                الحضور
              </button>
              <button className={`px-4 py-3 font-medium ${activeTab === 'documents' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('documents')} data-id="element-1408">
                المستندات
              </button>
              <button className={`px-4 py-3 font-medium ${activeTab === 'minutes' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('minutes')} data-id="element-1409">
                محضر الاجتماع
              </button>
            </div>
            <div className="p-6" data-id="element-1410">
              {/* Agenda Tab */}
              {activeTab === 'agenda' && <div data-id="element-1411">
                  <div className="flex justify-between items-center mb-4" data-id="element-1412">
                    <h3 className="text-lg font-semibold" data-id="element-1413">
                      جدول أعمال الاجتماع
                    </h3>
                    <button className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1414">
                      <Plus size={14} className="ml-1" data-id="element-1415" />
                      إضافة بند
                    </button>
                  </div>
                  <div className="space-y-4" data-id="element-1416">
                    {meeting.agenda.map((item, index) => <div key={item.id} className="flex items-start border border-gray-200 rounded-lg p-4" data-id="element-1417">
                        <div className="h-6 w-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 font-medium ml-3 mt-1" data-id="element-1418">
                          {index + 1}
                        </div>
                        <div className="flex-1" data-id="element-1419">
                          <div className="flex justify-between" data-id="element-1420">
                            <h4 className="font-medium" data-id="element-1421">{item.title}</h4>
                            <span className="text-sm text-gray-500" data-id="element-1422">
                              {item.duration}
                            </span>
                          </div>
                          <p className="text-sm text-gray-500" data-id="element-1423">
                            المقدم: {item.presenter}
                          </p>
                        </div>
                      </div>)}
                  </div>
                </div>}
              {/* Attendees Tab */}
              {activeTab === 'attendees' && <div data-id="element-1424">
                  <div className="flex justify-between items-center mb-4" data-id="element-1425">
                    <h3 className="text-lg font-semibold" data-id="element-1426">حضور الاجتماع</h3>
                    <button className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1427">
                      <Plus size={14} className="ml-1" data-id="element-1428" />
                      إضافة حاضر
                    </button>
                  </div>
                  <div className="overflow-x-auto" data-id="element-1429">
                    <table className="w-full" data-id="element-1430">
                      <thead data-id="element-1431">
                        <tr className="bg-gray-50" data-id="element-1432">
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1433">
                            الاسم
                          </th>
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1434">
                            الدور
                          </th>
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1435">
                            الحالة
                          </th>
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1436">
                            الإجراءات
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-1437">
                        {meeting.attendees.map(attendee => <tr key={attendee.id} data-id="element-1438">
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-1439">
                              <div className="flex items-center" data-id="element-1440">
                                <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3" data-id="element-1441">
                                  {attendee.name.charAt(0)}
                                </div>
                                <span className="font-medium" data-id="element-1442">
                                  {attendee.name}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-1443">
                              <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${attendee.role === 'رئيس اللجنة' ? 'bg-blue-100 text-blue-800' : attendee.role === 'أمين السر' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1444">
                                {attendee.role}
                              </span>
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-1445">
                              <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(attendee.status)}`} data-id="element-1446">
                                {attendee.status === 'confirmed' ? 'مؤكد' : attendee.status === 'pending' ? 'معلق' : attendee.status === 'declined' ? 'معتذر' : attendee.status}
                              </span>
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-1447">
                              <button className="text-red-500 hover:text-red-700 ml-2" data-id="element-1448">
                                <X size={16} data-id="element-1449" />
                              </button>
                              <button className="text-blue-500 hover:text-blue-700" data-id="element-1450">
                                <Edit size={16} data-id="element-1451" />
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>}
              {/* Documents Tab */}
              {activeTab === 'documents' && <div data-id="element-1452">
                  <div className="flex justify-between items-center mb-4" data-id="element-1453">
                    <h3 className="text-lg font-semibold" data-id="element-1454">مستندات الاجتماع</h3>
                    <button className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1455">
                      <Plus size={14} className="ml-1" data-id="element-1456" />
                      تحميل مستند
                    </button>
                  </div>
                  <div className="space-y-3" data-id="element-1457">
                    {meeting.documents.map(document => <div key={document.id} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-1458">
                        <div className="flex items-center" data-id="element-1459">
                          {getFileIcon(document.type)}
                          <span className="mr-2 font-medium" data-id="element-1460">
                            {document.name}
                          </span>
                          <span className="mr-2 text-xs text-gray-500" data-id="element-1461">
                            {document.size}
                          </span>
                        </div>
                        <div className="flex space-x-2" data-id="element-1462">
                          <button className="p-1 text-blue-500 hover:text-blue-700" data-id="element-1463">
                            <FileText size={16} data-id="element-1464" />
                          </button>
                          <button className="p-1 text-green-500 hover:text-green-700 mr-2" data-id="element-1465">
                            <Download size={16} data-id="element-1466" />
                          </button>
                          <button className="p-1 text-red-500 hover:text-red-700 mr-2" data-id="element-1467">
                            <Trash2 size={16} data-id="element-1468" />
                          </button>
                        </div>
                      </div>)}
                  </div>
                </div>}
              {/* Minutes Tab */}
              {activeTab === 'minutes' && <div data-id="element-1469">
                  <div className="flex justify-between items-center mb-4" data-id="element-1470">
                    <h3 className="text-lg font-semibold" data-id="element-1471">محضر الاجتماع</h3>
                    <div className="space-x-2" data-id="element-1472">
                      <button className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors" data-id="element-1473">
                        <Edit size={14} className="inline ml-1" data-id="element-1474" />
                        تعديل المحضر
                      </button>
                      <button className="px-3 py-1 bg-green-500 text-white text-sm rounded-md hover:bg-green-600 transition-colors mr-2" data-id="element-1475">
                        <Download size={14} className="inline ml-1" data-id="element-1476" />
                        تصدير
                      </button>
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-1477">
                    <h4 className="font-medium mb-3" data-id="element-1478">ملاحظات المناقشة</h4>
                    <div className="space-y-4" data-id="element-1479">
                      {meeting.minutes.notes.map(note => <div key={note.id} className="border border-gray-200 rounded-lg p-4" data-id="element-1480">
                          <h5 className="font-medium mb-2" data-id="element-1481">
                            {note.agenda_item}
                          </h5>
                          <p className="text-gray-700" data-id="element-1482">{note.content}</p>
                        </div>)}
                    </div>
                  </div>
                  <div data-id="element-1483">
                    <h4 className="font-medium mb-3" data-id="element-1484">بنود العمل</h4>
                    <div className="overflow-x-auto" data-id="element-1485">
                      <table className="w-full" data-id="element-1486">
                        <thead data-id="element-1487">
                          <tr className="bg-gray-50" data-id="element-1488">
                            <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1489">
                              المهمة
                            </th>
                            <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1490">
                              المسؤول
                            </th>
                            <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1491">
                              تاريخ الاستحقاق
                            </th>
                            <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1492">
                              الإجراءات
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200" data-id="element-1493">
                          {meeting.minutes.action_items.map(item => <tr key={item.id} data-id="element-1494">
                              <td className="px-4 py-2" data-id="element-1495">
                                <div className="font-medium" data-id="element-1496">
                                  {item.description}
                                </div>
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap" data-id="element-1497">
                                {item.assignee}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap" data-id="element-1498">
                                {item.due_date}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap" data-id="element-1499">
                                <button className="text-orange-500 hover:text-orange-700 ml-2" data-id="element-1500">
                                  <Edit size={16} data-id="element-1501" />
                                </button>
                                <button className="text-red-500 hover:text-red-700" data-id="element-1502">
                                  <Trash2 size={16} data-id="element-1503" />
                                </button>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
        </div>
        {/* Sidebar */}
        <div data-id="element-1504">
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1505">
            <h3 className="text-lg font-semibold mb-4" data-id="element-1506">إجراءات سريعة</h3>
            <div className="space-y-3" data-id="element-1507">
              <button className="w-full flex items-center justify-center p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1508">
                <Video size={18} className="ml-2" data-id="element-1509" />
                الانضمام للاجتماع
              </button>
              <button className="w-full flex items-center justify-center p-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors" data-id="element-1510">
                <FileText size={18} className="ml-2" data-id="element-1511" />
                عرض جدول الأعمال
              </button>
              <button className="w-full flex items-center justify-center p-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors" data-id="element-1512">
                <MessageSquare size={18} className="ml-2" data-id="element-1513" />
                إرسال تذكير
              </button>
              <button className="w-full flex items-center justify-center p-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors" data-id="element-1514">
                <Calendar size={18} className="ml-2" data-id="element-1515" />
                إضافة إلى التقويم
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1516">
            <h3 className="text-lg font-semibold mb-4" data-id="element-1517">التعليقات</h3>
            <div className="space-y-4 mb-4" data-id="element-1518">
              {meeting.comments.map(comment => <div key={comment.id} className="flex" data-id="element-1519">
                  <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3 flex-shrink-0" data-id="element-1520">
                    {comment.avatar}
                  </div>
                  <div className="bg-gray-100 p-3 rounded-lg flex-1" data-id="element-1521">
                    <div className="flex justify-between items-center mb-1" data-id="element-1522">
                      <span className="font-medium" data-id="element-1523">{comment.user}</span>
                      <span className="text-xs text-gray-500" data-id="element-1524">
                        {comment.date} في {comment.time}
                      </span>
                    </div>
                    <p className="text-sm" data-id="element-1525">{comment.content}</p>
                  </div>
                </div>)}
            </div>
            <div className="flex items-center mt-4" data-id="element-1526">
              <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3" data-id="element-1527">
                أ
              </div>
              <div className="flex-1 relative" data-id="element-1528">
                <input type="text" placeholder="إضافة تعليق..." className="w-full border border-gray-200 rounded-md px-4 py-2 pl-10 focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1529" />
                <button className="absolute left-2 top-1/2 transform -translate-y-1/2 text-orange-500" data-id="element-1530">
                  <Send size={18} className="transform rotate-180" data-id="element-1531" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Attendance Modal */}
      {showAttendanceModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-1532">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6" data-id="element-1533">
            <div className="flex justify-between items-center mb-4" data-id="element-1534">
              <h3 className="text-lg font-semibold" data-id="element-1535">تسجيل الحضور</h3>
              <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowAttendanceModal(false)} data-id="element-1536">
                <X size={20} data-id="element-1537" />
              </button>
            </div>
            <div className="mb-4" data-id="element-1538">
              <p className="text-gray-500 mb-2" data-id="element-1539">
                تسجيل الحضور لـ: <strong data-id="element-1540">{meeting.title}</strong> في{' '}
                <strong data-id="element-1541">{meeting.date}</strong>
              </p>
            </div>
            <div className="overflow-y-auto max-h-96" data-id="element-1542">
              <table className="w-full" data-id="element-1543">
                <thead data-id="element-1544">
                  <tr className="bg-gray-50" data-id="element-1545">
                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1546">
                      الاسم
                    </th>
                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1547">
                      الدور
                    </th>
                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1548">
                      الحضور
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1549">
                  {meeting.attendees.map(attendee => <tr key={attendee.id} data-id="element-1550">
                      <td className="px-4 py-2 whitespace-nowrap" data-id="element-1551">
                        <div className="flex items-center" data-id="element-1552">
                          <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3" data-id="element-1553">
                            {attendee.name.charAt(0)}
                          </div>
                          <span className="font-medium" data-id="element-1554">{attendee.name}</span>
                        </div>
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap" data-id="element-1555">
                        <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${attendee.role === 'رئيس اللجنة' ? 'bg-blue-100 text-blue-800' : attendee.role === 'أمين السر' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1556">
                          {attendee.role}
                        </span>
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap" data-id="element-1557">
                        <select className="border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1558">
                          <option value="present" data-id="element-1559">حاضر</option>
                          <option value="absent" data-id="element-1560">غائب</option>
                          <option value="excused" data-id="element-1561">معتذر</option>
                          <option value="late" data-id="element-1562">متأخر</option>
                        </select>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="flex justify-end space-x-3 mt-6" data-id="element-1563">
              <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={() => setShowAttendanceModal(false)} data-id="element-1564">
                إلغاء
              </button>
              <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors mr-3" onClick={() => setShowAttendanceModal(false)} data-id="element-1565">
                حفظ الحضور
              </button>
            </div>
          </div>
        </div>}
    </div>;
}